import { render } from "./ViewCatalogs.vue?vue&type=template&id=4582adb1&scoped=true&ts=true"
import script from "./ViewCatalogs.vue?vue&type=script&lang=ts"
export * from "./ViewCatalogs.vue?vue&type=script&lang=ts"

import "./ViewCatalogs.vue?vue&type=style&index=0&id=4582adb1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4582adb1"]])

export default __exports__